// start new file
export default function Vote() {
  return <h1>Vote Page | Del </h1>;
}